export const SITE = {
  name: "Victor Kwawukume",
  tagline: "Author • Journalist • Healthcare Professional • Musician • Advocate",
  email: "contact@victorkwawukume.com",
  location: "Toronto, Canada / Accra, Ghana",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/books", label: "Books" },
  { to: "/journalism", label: "Journalism" },
  { to: "/speaking", label: "Speaking" },
  { to: "/foundation", label: "Foundation" },
  { to: "/contact", label: "Contact" },
];

export const BOOKS = [
  {
    slug: "glass-ceiling-of-life",
    title: "The Glass Ceiling of Life",
    tagline: "A memoir of migration, resilience, and reinvention",
    cover:
      "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/8otqofqr_THE%20GLASS%20CEILING%20OF%20LIFE.png",
    description:
      "One dream. Two worlds. A lifetime of breaking boundaries. From the Independence Arch in Accra to the Toronto waterfront, Victor traces the true story of leaving everything behind to build a future without limits — and the quiet, often costly work of rewriting the rooms others built for you.",
    pull:
      "“You don’t just move countries. You rebuild your entire life.”",
    year: "2022",
  },
  {
    slug: "gobe",
    title: "Gobe",
    tagline: "The Woman Who Fed a Generation",
    cover:
      "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/rmqaerkb_GOBE.png",
    description:
      "She fed seven children. She nourished a generation. ‘Gobe’ is the love-letter Victor has carried for years — a portrait of a Ghanaian mother whose bowls of food, market mornings, and unyielding faith built the people now holding their own worlds together.",
    pull: "“She fed seven children. She nourished a generation.”",
    year: "2023",
  },
  {
    slug: "holding-the-world-together",
    title: "Holding the World Together",
    tagline: "Stories of Care, Dignity, and Human Connection",
    cover:
      "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/oihvduhd_HOLDING%20THE%20WORLD%20TOGETHER.png",
    description:
      "The quiet courage of those who care when caring matters most. Part memoir, part dispatch from Toronto’s frontline care homes, this is the book Canada needed someone like Victor to write — about dignity, compassion and the invisible architecture of a country that depends on its newcomers.",
    pull: "“Every day. Every person. Every moment.”",
    year: "2024",
  },
  {
    slug: "when-gods-fall-silent",
    title: "When Gods Fall Silent",
    tagline: "A novel of power, betrayal, and the search for meaning in a world without answers",
    cover:
      "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/byqz54z3_WHEN%20GOD%27S%20FALL%20SILENT.png",
    description:
      "Power fades. Thrones crumble. But what happens when the gods fall silent? A sweeping epic of history, faith, and the human spirit — Victor walks the ruined colonnades of an old empire and the inner ruins of one man, asking what a person must do when the heavens stop answering and the choice belongs only to him.",
    pull:
      "“In the silence of fallen gods, humankind must choose its own destiny.”",
    year: "2025",
  },
  {
    slug: "the-silent-monk",
    title: "The Silent Monk",
    tagline: "A novel of faith, discipline, and the search for truth beyond the world",
    cover:
      "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/n5vlyu5g_THE%20SILENT%20MONK.png",
    description:
      "A journey into silence. A life that chose meaning over noise. From the prayer-flagged ridges of a mountain monastery to the close, listening interior of a single human heart, ‘The Silent Monk’ asks what a person must give up — and what they finally find — when they trade the noise of the world for the long discipline of stillness.",
    pull:
      "“In the end, silence is not an escape from life, but a return to what is real.”",
    year: "2025",
  },
  {
    slug: "the-hundredth-keeper",
    title: "The Hundredth Keeper",
    tagline: "A novel of memory, lineage, and the cycle that ends with one girl",
    cover:
      "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/zycnw4e6_THE%20HUNDREDTH%20KEEPER.png",
    description:
      "For ninety-nine generations the Keepers have carried the Book. The hundredth Keeper will have no voice — and the hundredth will end the Cycle. Victor’s first sweeping novel braids Adinkra cosmology, ancestral memory and a young girl’s reckoning into a story of inheritance, silence and the courage to close a circle no one else dared.",
    pull:
      "“The hundredth Keeper will have no voice. The hundredth will end the Cycle.”",
    year: "2025",
  },
  {
    slug: "the-last-presidential-correspondent",
    title: "The Last Presidential Correspondent",
    tagline: "A novel of power, the press, and the sentence that lasted thirty years",
    cover:
      "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/5v79ct4w_THE%20LAST%20PRESIDENTIAL%20CORRESPONDENT.png",
    description:
      "He wrote the sentence that saved a nation. Thirty years later he learns it was a lie. Drawing on his own years inside Ghana’s executive press corps, Victor turns a reporter’s notebook into a political thriller about truth, complicity, and the long memory of a state — and a man — built on a single carefully chosen line.",
    pull:
      "“He wrote the sentence that saved a nation. Thirty years later he learns it was a lie.”",
    year: "2026",
  },
];

export const JOURNALISM = [
  {
    title: "Inside the Last Cabinet: A Presidential Correspondent's Notebook",
    publication: "Daily Graphic",
    year: "2018",
    category: "Presidential Coverage",
    excerpt:
      "A close-quarters account of the final weeks of an administration — the late-night briefings, the unrecorded confessions, the policy decisions that did not survive their own announcement.",
  },
  {
    title: "When Aid Becomes Architecture: Ghana's Donor Dilemma",
    publication: "Africa Watch",
    year: "2019",
    category: "Governance",
    excerpt:
      "Investigative reporting on how decades of aid have quietly reshaped the country's policy machinery — and what is now owed back to the citizens those policies are meant to serve.",
  },
  {
    title: "The Volta Is Rising: Climate Displacement on Ghana's Eastern Edge",
    publication: "Award-winning feature",
    year: "2020",
    category: "Climate & Public Affairs",
    excerpt:
      "A months-long field investigation into communities being slowly erased by rising waters — and the public health emergency unfolding in their wake. Awarded by the Ghana Journalists Association.",
  },
  {
    title: "The Long Walk to Trillium: Foreign-Trained Nurses in Ontario",
    publication: "The Globe & Mail (Op-Ed)",
    year: "2023",
    category: "Public Affairs",
    excerpt:
      "An argument for credentialing reform, written from inside a system that needs Victor as much as he needed Canada — and the moral cost of pretending otherwise.",
  },
  {
    title: "Holding Power Accountable: A Reporter's Code",
    publication: "Joy News",
    year: "2017",
    category: "Governance",
    excerpt:
      "On the discipline of asking the next question, even when the room would prefer a comfortable answer. Notes from a decade in the press corps.",
  },
  {
    title: "Health on a Warming Continent",
    publication: "Lancet Africa Commentary",
    year: "2024",
    category: "Climate & Public Affairs",
    excerpt:
      "Reframing climate change as the single largest public-health crisis Africa will face this century — and what frontline workers, ministers, and donors must agree to next.",
  },
];

export const SPEAKING_TOPICS = [
  {
    title: "Journalism in the Age of Distrust",
    summary:
      "What public-interest reporting still owes the public, and what newsrooms must rebuild to keep the contract intact.",
  },
  {
    title: "Migration & the Making of New Lives",
    summary:
      "From the green-card line to the night-shift ward — the unspoken curriculum of becoming somewhere else.",
  },
  {
    title: "Leadership Under Pressure",
    summary:
      "Lessons drawn from years inside Ghana's executive press corps and Ontario's frontline healthcare system.",
  },
  {
    title: "Climate Change & Public Health",
    summary:
      "Why the next decade of African health policy must be written with one eye on the sky and another on the water.",
  },
  {
    title: "Resilience as a Practice, Not a Personality",
    summary:
      "Reframing endurance as a craft — what it requires, what it costs, and what it gives back.",
  },
  {
    title: "Community, Foundation & the Work of Giving Back",
    summary:
      "Building durable institutions from a single conviction: that no one is meant to carry their world alone.",
  },
];

export const FOUNDATION_PILLARS = [
  {
    title: "Climate-Health Field Clinics",
    body:
      "Mobile health interventions in coastal and Volta-belt communities where rising waters, heat, and displacement are already producing measurable health burdens.",
  },
  {
    title: "Frontline Worker Scholarships",
    body:
      "Bursaries for Ghanaian nurses, midwives and community-health workers pursuing further training at home and abroad.",
  },
  {
    title: "Climate Advocacy & Reporting Fellowships",
    body:
      "Funded fellowships for African journalists covering the intersection of climate, governance and public health — the stories the world cannot afford to miss.",
  },
];

export const AWARDS = [
  "Ghana Journalists Association — Feature of the Year",
  "Presidential Press Corps — Coverage Excellence",
  "Climate Reporting Fellowship — West Africa Cohort",
  "Canadian Newcomer Magazine — Voice of the Year (Nominee)",
];

export const IMAGES = {
  // Hero — do not change without explicit request
  authorPortrait:
    "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/b5m2nqlw_file_00000000c970722fa125add071455e45.png",
  // About page lead — Graphic newsroom standing portrait
  aboutPortrait:
    "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/4ppo7en9_IMG-20260603-WA0040.jpg",
  // Journalism — press conference microphone photo
  journalismScene:
    "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/fz5lulhf_FB_IMG_1780494057424.jpg",
  // Presidential Correspondent — with H.E. Nana Akufo-Addo
  presidentialPhoto:
    "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/69gyf9xp_IMG-20260603-WA0043.jpg",
  // Career Journey / Canada Transition — factory worker (mitre saw)
  canadaTransition:
    "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/47i6734c_IMG-20260603-WA0033.jpg",
  // Starting Again — factory / warehouse floor (primary visual)
  factoryFloor:
    "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/bauzhmnn_IMG-20260603-WA0031.jpg",
  // Speaking / Advocacy — labour rally microphone photo
  speakingPodium:
    "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/u01gs5k3_FB_IMG_1780494148990.jpg",
  // Delinam Foundation — climate/community placeholder (awaiting real assets)
  foundation:
    "https://images.pexels.com/photos/35043641/pexels-photo-35043641.jpeg",
  heroTexture:
    "https://images.pexels.com/photos/7233374/pexels-photo-7233374.jpeg",
};

export const JOURNEY_VIDEOS = [
  {
    id: "warehouse-equipment",
    title: "Warehouse & equipment operation",
    description:
      "Inside the manufacturing floor — reach trucks, forklifts, and the daily work of starting again.",
    src: "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/o8mqtkzp_VID-20260605-WA0010.mp4",
    poster:
      "https://customer-assets.emergentagent.com/job_kwawukume-author/artifacts/bauzhmnn_IMG-20260603-WA0031.jpg",
  },
];

export const IMAGE_CAPTIONS = {
  journalismScene:
    "Reporting from the front lines of national discourse — asking questions that mattered and bringing critical public-interest stories to citizens.",
  presidentialPhoto:
    "Serving as a Presidential Correspondent — covering governance, leadership, policy, and national development.",
  canadaTransition:
    "Beginning again in Canada — embracing every opportunity with dignity, resilience, and determination.",
  speakingPodium:
    "Championing the voices of ordinary people through journalism, advocacy, and public engagement.",
  aboutPortrait:
    "Journalist, communicator, storyteller, advocate, and lifelong believer in the power of informed citizens.",
};
